import React from 'react'
// Removed unused Box import
import Slider from '@mui/material/Slider';

function valuetext(value) {
  return `${value}°C`;
}

export default function AgeFilter(props) {
  const handleChange = (event, newValue) => {
    props.setAge(getQueryFromList(newValue));
  };

  const handle = (event, newValue) => {
    setValue(newValue);
  };

  const getListFromQuery = (query) => {
    if (query === undefined || query === null) {
      return [0, 20]
    }
    const elements = query.split(',')
    if (elements.length === 1) {
      return [parseInt(elements[0]), parseInt(elements[0]) + 1]
    }
    return [parseInt(elements[0]), parseInt(elements[1])]
  }

  const getQueryFromList = (list) => {
    if (list[0] === 0 && list[1] === 20) {
      return null}
    return list[0] + ',' + list[1]
  }

  const [value, setValue] = React.useState(getListFromQuery(props.age));

  const marks = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 5,
      label: '5',
    },
    {
      value: 10,
      label: '10',
    },
    {
      value: 15,
      label: '15',
    },
    {
      value: 20,
      label: '20',
    },
  ];

  return (
      <Slider
        marks={marks}
        getAriaLabel={() => 'Alter'}
        value={value}
        onChange={handle}
        onChangeCommitted={handleChange}
        valueLabelDisplay="auto"
        getAriaValueText={valuetext}
        max={20}
        name='ageID'
      />
  );
}
